import Layout from 'components/organisms/Layout';
import { LayoutTriggerValueType } from 'defs/layout';
import { connect } from 'react-redux';
import { getCurrentOptions, getGoTopTimestamp, getIsBodyLocked, getTriggerComponent } from 'store/layout';

export type LayoutContainerPropsType = {
	opts?: Object;
	bodyLocked?: boolean | null;
	goTopStamp?: string | null;
	triggerComponent?: LayoutTriggerValueType;
};

const mapStateToProps = (state) => ({
	bodyLocked: getIsBodyLocked(state),
	goTopStamp: getGoTopTimestamp(state),
	currentOptions: getCurrentOptions(state),
	triggerComponent: getTriggerComponent(state),
});

export default connect(mapStateToProps)(Layout as any);
